import React, { useState } from 'react'
import { baseURLProd } from '../../api';
import { toast } from 'react-toastify';

const LoginHook = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
 
    const handleLogin = async (e) => {
      e.preventDefault();
  
      const formData = new FormData();
      formData.append("email", username);
      formData.append("password", password);
  
      try {
        const loginResponse = await fetch(`${baseURLProd}login`, {
          method: "POST",
          body: formData,
        });
  
        const loginData = await loginResponse.json();
  
        if (loginData.status === true) {
          toast.success(loginData.message);
          localStorage.setItem("userId", loginData.user_id);
          localStorage.setItem("showAttendancePopup", "true");
          window.location.href = "/home";
        } else {
          alert("Login failed: " + loginData.message);
        }
      } catch (error) {
        console.error("Error during login process:", error);
        alert("An error occurred. Please try again later.");
      }
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
      const handleClickShowPassword2 = () => {
        setShowPassword2(!showPassword2);
      };

  return {
    handleLogin,showPassword,handleClickShowPassword,showPassword2,handleClickShowPassword2,username,setUsername,password,setPassword,
  
  }
}

export default LoginHook
